export const ID = 'USER_FORM';

export const RESTORE_USER = `${ID}/RESTORE_USER`;
